export const pageTitle = title => {
  return (document.title =
    title + ' | Hybrid One Carpentry');
};
